module.exports = __webpack_public_path__ + "static/media/icon.84e0b8de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icon.jpg
// module id = 123
// module chunks = 0